export enum OrderTypeEnum {
    LTL = 'LTL',
    FTL = 'FTL',
    EXPRESS = 'EXPRESS',
}
